// Hooks the Teaching Resources card list into the Buy buttons form.
// After the main product is successfully added to the cart, fetches /cart/add.js
// with the selected resource variants and dispatches a cart-update so the cart drawer refreshes.

(() => {
  const SELECTOR = '.tefl-teaching-resources';

  function initBlock(block) {
    if (block.__teflResourcesInit) return;
    block.__teflResourcesInit = true;

    const productId = block.dataset.parentProductId;
    if (!productId) return;

    // Find the matching product-form-component for the current product
    const form = document.querySelector(`product-form-component[data-product-id="${productId}"]`);
    if (!form) return;

    form.addEventListener('cart:update', async (event) => {
      const detail = event?.detail || {};
      if (detail?.data?.didError) return;
      if (detail?.data?.source !== 'product-form-component') return;
      if (String(detail?.data?.productId) !== String(productId)) return;

      const checked = Array.from(block.querySelectorAll('input[type="checkbox"][data-variant-id]:checked'));
      if (checked.length === 0) return;

      const items = checked.map((input) => ({
        id: Number(input.dataset.variantId),
        quantity: 1
      }));

      try {
        const res = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!res.ok) {
          console.warn('[teaching-resources] cart/add failed:', await res.text());
          return;
        }
        // Refresh cart drawer / icon by re-fetching cart and dispatching a generic update
        const cartRes = await fetch('/cart.js');
        if (cartRes.ok) {
          const cart = await cartRes.json();
          form.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              data: { source: 'teaching-resources', didError: false }
            }
          }));
        }
        // Uncheck so they don't get added again on a second submission
        checked.forEach((input) => { input.checked = false; });
        syncCardStates(block);
      } catch (err) {
        console.warn('[teaching-resources] error:', err);
      }
    });

    // Visual state on selection change
    block.addEventListener('change', (e) => {
      if (e.target.matches('input[type="checkbox"][data-variant-id]')) {
        syncCardStates(block);
        updateSelectionSummary(block);
      }
    });
    syncCardStates(block);
    updateSelectionSummary(block);
  }

  function syncCardStates(block) {
    block.querySelectorAll('.tefl-teaching-resources__card').forEach((card) => {
      const input = card.querySelector('input[type="checkbox"]');
      card.classList.toggle('is-selected', !!input?.checked);
    });
  }

  function updateSelectionSummary(block) {
    const summary = block.querySelector('[data-summary]');
    if (!summary) return;
    const checked = block.querySelectorAll('input[type="checkbox"][data-variant-id]:checked');
    summary.textContent = checked.length
      ? `${checked.length} resource${checked.length === 1 ? '' : 's'} will be added to your cart.`
      : '';
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after section reload in theme editor
  document.addEventListener('shopify:section:load', init);
})();
